<div class="inspection-category-item width-100p mt-2 mb-2 pointer">
  <div class="category-item-header flex-between-center">
    <div class="flex-start-center inspection-item-title">
      <p class="inspection-title m-0 font-600">
        {{ inspectionItem?.title }}
      </p>
    </div>

    <div class="inspection-item-condition flex-between-center">
      <div class="flex-start-center position-relative" [ngClass]="{ 'not-allowed': workStatus === 'inprogress' }">
        <div [ngClass]="{ 'disabled-radio': isArchived }"></div>
        <a href="javascript:void(0)" class="inline-block p-1"
          [ngClass]="{ 'inspection-state': workStatus === 'inprogress' }" (click)="handleChange('colorIndex', 0)">
          <div class="inspection-item-color good-hover" [ngClass]="{ good: inspectionItem?.colorIndex === 0 }"></div>
        </a>

        <a href="javascript:void(0)" class="inline-block p-1"
          [ngClass]="{ 'inspection-state': workStatus === 'inprogress' }" (click)="handleChange('colorIndex', 1)">
          <div class="inspection-item-color normal-hover" [ngClass]="{ normal: inspectionItem?.colorIndex === 1 }">
          </div>
        </a>

        <a href="javascript:void(0)" class="inline-block p-1"
          [ngClass]="{ 'inspection-state': workStatus === 'inprogress' }" (click)="handleChange('colorIndex', 2)">
          <div class="inspection-item-color bad-hover" [ngClass]="{ bad: inspectionItem?.colorIndex === 2 }"></div>
        </a>
      </div>
    </div>

    <div class="tech-status">
      <div class="heading">
        Assigned service:&nbsp;
      </div>
      <div class="status mr-20" *ngIf="active">
        <div class="single-row" *ngFor="let row of items; let i = index">
          <div class="column service">
            <div class="text-truncate" tooltipPosition="top"
            [pTooltip]="row?.content.length > 15 && row?.content"
            >
              {{ row?.splitContent || row?.content }}
            </div>
            <span>
              <i class="far fa-times pointer dialog-close" (click)="removeAssociatedService(row,i)"></i>
            </span>
          </div>
          <div class="clearfix" *ngIf="i % 2 === 1 || i === items.length - 1"></div>
        </div>
      </div>

      <div class="status" *ngIf="!active">
        &nbsp; {{items.length}} service assigned
      </div>
    </div>
  </div>

  <div class="category-item-body">
    <!-- [hidden]="inspectionItem.colorIndex <= -1 || !addMediaToInspectionEnabled" -->
    <div class="attachment-action-wrapper flex-start-center" [ngClass]="{ 'not-allowed': workStatus === 'inprogress' }">
      <!-- Image attatchments -->
      <div>
        <div class="attachment-label">Attachments</div>
        <div class="d-flex">
          <div class="flex-start-center flex-wrap inpection-media-wrapper">
            <div class="inpection-media-container">
              <div class="inpection-media-row" [ngClass]="{'d-none': !active && i > 8 , 
              'w-40': inspectionItem?.attachments.length < 8}"
                *ngFor="let attachment of inspectionItem?.attachments; let i = index">
                <div class="column">
                  <div *ngIf="attachment.type === 'image'" class="inspection-media flex-center-center ml-1 mt-1">
                    <div class="attachment-fg-overlay"
                      (click)="openImagePreview(inspectionItem?.attachments, attachment)"></div>
                    <img [src]="attachment.url" *ngIf="attachment.url" class="inspection-item-image" alt=""
                      (click)="openImagePreview(inspectionItem?.attachments, attachment)" />
                  </div>
                  <div *ngIf="attachment.type === 'video'" class="inspection-media flex-center-center ml-1 mt-1">
                    <i class="fal fa-play video-zoom pointer"
                      (click)="openImagePreview(inspectionItem?.attachments, attachment)"></i>
                    <div class="attachment-fg-overlay" (click)="openImagePreview(inspectionItem?.attachments)">
                    </div>
                    <video class="inspection-item-video" *ngIf="attachment.url"
                      (click)="openImagePreview(inspectionItem?.attachments, attachment)">
                      <source [src]="attachment.url" type="video/mp4" />
                    </video>
                  </div>
                </div>
                <div class="clearfix" *ngIf="i === 9"></div>
              </div>

              <div *ngIf="isUploading" class="inspection-media flex-center-center ml-1 mt-1">
                <i class="fal fa-spinner rotate"></i>
              </div>
              <ng-container *ngIf="inspectionItem?.attachments.length > 9 && !active">
                <div class="attachment-add-icon ml-1 mt-1">
                  +{{inspectionItem?.attachments.length - 9}}
                </div>
              </ng-container>
              <div class="attachment-add-icon ml-1 mt-1" *ngIf="active">
                <div class="inspection-media flex-center-center">
                  <button class="btn font-12 text-center"
                    [disabled]="inspectionItem.colorIndex <= -1 || workStatus === 'inprogress' || isArchived"
                    [ngStyle]="{ cursor: workStatus === 'inprogress' ? 'not-allowed' : 'pointer', 'z-index': 99 }"
                    (click)="handleBrowse(fileUpload)">
                    <i class="fal fa-plus font-16"></i>
                  </button>
                </div>
                <input type="file" (click)="fileUpload.value = ''; fileUpload.click()" class="d-none"
                  accept="video/*,image/*" (change)="handleUpload($event)" #fileUpload />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="inspection-item-notes" [ngStyle]="{ cursor: workStatus === 'inprogress' ? 'not-allowed' : 'pointer' }">
      <app-textarea styleClass="pt-0" placeholder="Add note" #textAreaRef
        [disabled]="inspectionItem.colorIndex <= -1 || workStatus === 'inprogress' || isArchived"
        [value]="inspectionItem?.notes" [autoGrow]="true" [maxAutoGrowHeight]="111"
        [textAreaId]="'notes' + inspectionItem?._id" (appChange)="handleChange('notes', $event)"
        (appFocus)="handleFocusChange('notes', true)" (appBlur)="handleFocusChange('notes', false)"></app-textarea>
    </div>

    <div [hidden]="!isDVICannedNotesEnabled" class="mt-2">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [closeAfterAction]="true" right="-5%"
        (appHide)="openCannedNotes()" (appShow)="openCannedNotes()"
        [disabled]="cannedNotes.length === 0 || inspectionItem.colorIndex <= -1">
        <ng-template appTemplate="item">
          <div class="add-canned-notes" [ngClass]="(!active || cannedNotes.length === 0) && 'disabled-canned-notes'">
            <span>Canned notes</span>
            <i class="flex-center-center fa mt-1" [ngClass]="[!closeAfterAction ? 'fa-angle-up' : 'fa-angle-down']"></i>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-403">
            <div class="filter-option border-bottom-lightest" (click)="onChange(notes)"
              *ngFor="let notes of cannedNotes">
              <app-checkbox [isChecked]="notes.isChecked" tooltipIconPosition="left" [tooltip]="notes.note">
              </app-checkbox>
              {{ notes.note }}
            </div>
          </div>
          <div class="canned-notes-footer flex-between-center w-403" *ngIf="!isLoadingNotes && cannedNotes?.length > 0">
            <div class="pointer" (click)="handleClearNotes()">Clear Selection</div>
            <div class="pointer" (click)="handleAddNotes()">Add {{ checkNotesLength() }} notes</div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
  </div>
  <!-- <div class="text-area-border-bottom" *ngIf="isTextAreaActive"></div> -->
</div>